export const TITLE_SUFFIX = '| Quince'
export const ELIGIBLE_LOCALES = ['en-ca', 'fr-ca', 'en-gb']
